import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import { update } from "lodash";

import UI from "./uiReducer";
import Auth from "./authReducer";
import Recipes from "./recipeReducer";
import AddRecipe from "./addRecipeReducer";
import FoodDatabase from "./foodDatabaseReducer";
import Resources from "./resourceReducer";
import WorkoutPlans from "./workoutPlanReducer";
import MyProgress from "./myProgressReducer";
import Exercises from "./exercisesReducer";
import MyFood from "./myFoodReducer";
import MyHistory from "./myHistoryReducer";
import MyWorkout from "./myWorkoutReducer";
import Home from "./homeReducer";
import Progress from "./progressReducer";
import NutritionJournal from "./nutritionJournalReducer";
import FitnessJournal from "./fitnessJournalReducer";
import AdManagement from "./adManagementReducer";
import MotivationManagement from "./motivationManagementReducer";
import Badges from "./badgeReducer";
import Testimonials from "./testimonialReducer";

import { COMMON } from "../types/actions";

const allReducers = combineReducers({
	UI,
	Auth,
	Recipes,
	AddRecipe,
	FoodDatabase,
	Resources,
	NutritionJournal,
	Exercises,
	form: formReducer,
	WorkoutPlans,
	MyFood,
	MyHistory,
	MyWorkout,
	MyProgress,
	Home,
	FitnessJournal,
	AdManagement,
	MotivationManagement,
	Progress,
	Badges,
	Testimonials
});

const rootReducer = (state, action) => {
	let newState = { ...state };
	switch (action.type) {
		case COMMON.RESET_FIELD:
			if (action.key) {
				newState = update(state, action.key, () => action.value);
			}
			return {
				...newState
			};
		default:
		// do nothing;
	}
	return allReducers(newState, action);
};

export default rootReducer;
